module.exports = __webpack_public_path__ + "img/id-icon.6836095d.svg";